import { render, staticRenderFns } from "./DrilldownItem.vue?vue&type=template&id=2f11ab39"
import script from "./DrilldownItem.vue?vue&type=script&lang=js"
export * from "./DrilldownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports